const agentUrls = {
  voice: "/agents/voice",
  whatsapp: "/agents/whatsapp",
  instagram: "/agents/instagram",
  interview: "/agents/interview",
  marketing: "/agents/marketing",
  finance: "/agents/finance",
  hr: "/agents/hr",
  banking: "/agents/banking",
};

export default agentUrls;
